import { noop } from 'lodash';
import { withProps, compose } from 'recompose';
import { Tool } from '@nextiva/rich-text-editor';

import styles from './LineHeightTextEditorToolToggle.scss';

export default compose(
  withProps({
    iconClassName: 'icon-custom-text-line-height',
    className: styles.toggle,
    onClick: noop,
  }),
)(Tool);
